import React, { useCallback, useEffect, useRef, useState } from "react";
import '../invoice.css';
import ExpenseInvoicePage from "./ExpenseInvoicePage";

const DownloadBtnExpensePdf = ({auth, loading}) => {
    const [timeLeft, setTimeLeft] = useState(5); 
    const [isActive, setIsActive] = useState(false);
    const [isClickToGeneratePDF, setIsClickToGeneratePDF] = useState(false);
    
    const triggerPDFGeneration = useCallback(() => {
        console.log("PDF Generation triggered!");
        setIsClickToGeneratePDF(true);
    }, []);
    
    useEffect(() => {
        let timer = null;
    
        if (isActive && timeLeft > 0) {
          timer = setInterval(() => {
            setTimeLeft((prev) => prev - 1);
          }, 1000);
        } else if (timeLeft === 0) {
          triggerPDFGeneration();
          timer = setTimeout(() => {
            setIsActive(false);
            loading(false);
            clearInterval(timer);
          }, 1000); 
        }
    
        return () => clearInterval(timer);
      }, [isActive, timeLeft, triggerPDFGeneration]);

   
      const startCountdown = () => {
        loading(true);
        setTimeLeft(5); 
        setIsActive(true);
        setIsClickToGeneratePDF(false); 
      };
   
    return (
        <>
            {
                isActive && <ExpenseInvoicePage auth={auth} isClickToGeneratePDF={isClickToGeneratePDF} />
            }
            <a className="dropdown-item" style={{ textTransform: 'capitalize', cursor: 'pointer' }} onClick={(e) => {
                e.preventDefault();
                startCountdown();
            }}>
                Download PDF
            </a>
        </>
    )
}
export default DownloadBtnExpensePdf;